import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';

const BaseFinancialButton = ({
  disabled = null,
  id = '',
  isSelected = false,
  name = '',
  onToggle
}) => {
  const disabledStyles = `${disabled && 'opacity-25 cursor-not-allowed'}`;

  return (
    <button
      disabled={disabled}
      style={{ width: '154px', height: '64px' }}
      className={`
      border border-cornflower-blue-500 rounded p-2 rounded mr-2 focus:outline-hidden
        ${
          isSelected
            ? 'bg-cornflower-blue-500 text-white font-bold'
            : 'font-medium active:bg-white/50 bg-white hover:bg-blue-200/25 hover:active:bg-blue-200/50 text-cornflower-blue-500'
        }
        ${disabledStyles}
      `}
      type="button"
      data-testid={id || `financial-${kebabCase(name)}`}
      onClick={onToggle}
    >
      {name}
    </button>
  );
};

BaseFinancialButton.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string,
  isSelected: PropTypes.bool,
  name: PropTypes.string,
  onToggle: PropTypes.func.isRequired
};

export default BaseFinancialButton;
